<template id="my-head-nav">
  <div ref="childref">
    <div class="header aem-GridColumn aem-GridColumn--default--12">
      <div class="mchp-header" id="mchp-header-top">
         <div class="mchp-bg-container">
             <div class="graphic"></div>
             <div class="mchp-top-bar">
                 <div class="mchp-logo">
                     <div id="logo-data"></div>
                 </div>
                 <div class="mchp-nav-container">
                     <nav class="cmp-navigation mchp-navigation">
                        <ul id="parent-ul" class="mchp-navigation_list hide-tablet">
                           <li class="mchp-navigation_item" v-for="(navItem, index) in myData.navData" :key="navItem.title" @mouseover="handleMouseOverParent(index)">
                              <div class="mchp-nav-link-holder">
                                 <a :href="navItem.path" :title="navItem.title" class="mchp-navigation_link">
                                    <span class="mchp-dropdown_text">{{navItem.title}}</span>
                                 </a>
                              </div>
                           </li>
                           <div id="mega-menu" @mouseleave="handleMouseLeave($event)" class="mchp-mega-menu hide-tablet hide-content">
                              <div class="all-categories column">
                                 <ul id="menu-ul" class="all-categories-list">
                                    <li v-for="(child, i) in filteredItem.children" :key="child.path" @mouseover="handleMouseOverChild(i)">
                                       <a :href="child.path" class="nav-link all-categories-item">
                                          <span>{{child.title}}</span>
                                          <i v-if="child.hasChild" class="fas fa-chevron-right chevron"></i>
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                              <div id="cat-detail" class="category-details column"></div>
                           </div>
                        </ul>
                        <!-- small screen -->
                        <div class="mchp-mobile-menu hide-desktop">
                           <ul class="mchp-navigation_list mobile-list hide-content parent-list">
                              <li v-for="(navItem, index) in myData.navData" :key="navItem.title" @click="handleMouseClickParent(index, $event)" class="mchp-navigation_item mchp-nav-link-holder">
                                 <a class="mchp-navigation_link current" :href="navItem.path">
                                    <span class="mchp-dropdown_text">{{navItem.title}}</span>
                                    <i v-if="navItem.hasChild" class="fas fa-chevron-right chevron"></i>
                                 </a>
                              </li>
                           </ul>
                           <ul class="mchp-navigation_list mobile-list hide-content child-list">
                              <li class="mchp-navigation_item mchp-nav-link-holder back is-active" @click="mobileBackBtnClick()">
                                    <a class="mchp-navigation_link bold-link back-link current" href="main" @click.prevent>
                                       <i class="fas fa-chevron-left back-chevron"></i>
                                       <span class="mchp-dropdown_text">Back</span>
                                    </a>
                              </li>
                              <li class="mchp-navigation_item mchp-nav-link-holder is-active">
                                    <a class="mchp-navigation_link bold-link" :href="filteredItemMobile.path">
                                       <span class="mchp-dropdown_text">Browse {{filteredItemMobile.title}}</span>
                                    </a>
                              </li>
                              <li v-for="(child) in filteredItemMobile.children" :key="child.path" @click="handleMouseClickChild(child)" class="mchp-navigation_item mchp-nav-link-holder is-active">
                                 <a v-if="child.hasChild" class="mchp-navigation_link">
                                    <span class="mchp-dropdown_text">{{child.title}}</span>
                                    <i class="fas fa-chevron-right chevron"></i>
                                 </a>
                                 <a v-else class="mchp-navigation_link" :href="child.path">
                                    <span class="mchp-dropdown_text">{{child.title}}</span>
                                    <i v-if="child.hasChild" class="fas fa-chevron-right chevron"></i>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </nav>
                 </div>
                 <div class="mobile-close" @click="toggleMobileNavMenu()">
                     <i class="fas fa-times"></i>
                  </div>
                 <div class="header-icons">
                     <img class="search-icon" 
                     :src="this.myData.searchIcon" 
                     alt="microchip-search-icon" @click="toggleSearchPopup()">
                     <a :href="this.myData.userLink" @mouseover="handleMouseOverUserMenu()" class="user-icon">
                           <img :src="this.myData.userIcon" alt="microchip-user-icon" class="header-icon">
                     </a>
                     <a :href="this.myData.cartLink" class="cart-icon">
                           <img :src="this.myData.cartIcon" alt="microchip-cart-icon" class="header-icon">
                     </a>
                 </div>
                 <div @click="toggleMobileNavMenu()" class="hamburger-holder">
                     <i class="fas fa-bars"></i>
                  </div>
             </div>
             <div class="spacer"></div>
         </div>
         <div id="user-menu-wrap">
            <div id="MyMicrochipMenu" @mouseleave="handleMouseLeaveUserMenu($event)" class="user-login-popup-style HideMyMicrochipMenu">
               <div class="mchp-card">
                  <div class="mchp-card-title">
                     <div>
                        <div class="mchp-component-title">
                              <h3 id="myMicrochipTitle" class="mchp-title__text">myMicrochip</h3>
                        </div>        
                     </div>
                  </div>
                  <div id="myloginpopup" class="cmp-text"></div>
                  <div class="mchp-card-buttons mchp-button-wrapper">
                     <a id="SignOutLink" class="mchp-button mchp-button-regular solid" href="https://www.microchip.com/mymicrochip/Logout.aspx" @click="deleteUserCookies()">Sign Out</a>
                  </div>
               </div>
            </div>
         </div>
     </div>
     <div>
      <div class="mchp-searchbar-url-base hidden">https://www.microchip.com/sitesearch/api/autosuggestapi/GetAutoSuggest</div>
      <div class="mchp-searchbar searchbar mchp-header-search">
         <div class="mchp-searchbar-results-overlay"></div>
         <div class="dropdown-header">
            <div class="mchp-header-searchbar-container">
               <div class="search-container">
                  <input type="search" v-model="userSearchInput" class="mchp-searchbar-input mchp-headersearch has-search-clear" placeholder="Search products, documents, software, and more..." name="search" autocomplete="off">
                  <span @click="clearSearchField()">
                     <i class="fas fa-times search-clear hide-content"></i>
                  </span>
              </div>
              <button type="submit" @click="goToSearchPageHome()"><i id="mchp-searchbar-icon" class="fas fa-search"></i></button>
            </div>
         </div>
         <div class="searchbar-content">
            <h3>Search products, tools, resources and more!</h3>
            <p>Start typing your search term, your results will display here.</p>
        </div>
        <div class="mchp-searchbar-dropdown" style="width: 127px;">
            <div class="mchp-searchbar-suggestion" style="display: none">
               <div v-for="(item, index) in searchSuggestionList" :key="index" class="mchp-searchterm-container" @click="goToSearchPage(item)">
                  {{item}}
               </div>
            </div>
         </div>
      </div>
     </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import HeadData from "../api/dataservice";
import DefaultHeaderData from "../FallBackFiles/DefaultHeader.json";

export default {
   name: "HeaderComponent",
    data() {
      return {
         myData: {},
         filteredItem: {},
         filteredItemMobile: {},
         userSelectedArray: [],
         userSelectedArrayMobile: [],
         parentIndexMobile: null,
         userSearchInput: '',
         searchSuggestionList: [],
         environment: 'stage'
      };
   },
   watch: {
    userSearchInput() {
      const searchClearIcon = document.getElementsByClassName('search-clear')[0];
      if (this.userSearchInput.length) {
         searchClearIcon.classList.remove('hide-content');
         this.getSearchResultsApi();
      } else {
         searchClearIcon.classList.add('hide-content');
      }
    }
  },
   mounted: function() {
      this.searchSuggestionList = [];
      if (this.environment === 'prod') {
      HeadData.getHeaderData('123')
               .then((data) => {
                  this.renderHeaderData(data);
               })
               .catch(function() {
               });
      } else {
         this.renderHeaderData(DefaultHeaderData);
      }
      window.addEventListener('resize', this.onWindowResize);
   },
    beforeDestroy: function () {
        window.removeEventListener('click', this.onClick);
        window.removeEventListener('click', this.deleteMyMicrochipAccount);
        window.removeEventListener('resize', this.onWindowResize);
    },
    methods: {
      // Get search results from API //
      renderHeaderData(data) {
         const deleteToken = window.$cookies.get("asdfdiuglkjhrsu");
         const userCookie = window.$cookies.get("wwwmicrochipuser");
         const userNameCookie = window.$cookies.get("wwwmicrochipusername");

         this.myData = data;
         let divLogo = document.getElementById("logo-data");
         let graphicData = document.getElementsByClassName('graphic')[0];
         let userPopupTextElement = document.getElementById(this.myData.loginPopupData.id);

         this.myData.loginPopupData.textIsRich ? userPopupTextElement.insertAdjacentHTML("beforeEnd",  this.myData.loginPopupData.text) : null;
         this.myData.graphicData.displayPopupTitle ? graphicData.insertAdjacentHTML("beforeEnd", `<div><div class="cmp-image"><img class="cmp-image__image" src="${this.myData.graphicData.linkURL}" alt="${this.myData.graphicData.alt}"></div></div>`) : null;
         this.myData.logoData.displayPopupTitle ? divLogo.insertAdjacentHTML("beforeEnd", `<div class="cmp-image"><a class="cmp-image__link" href="https://www.microchip.com/">
         <img src="${this.myData.logoData.linkURL}" class="cmp-image__image" alt="${this.myData.logoData.alt}">
         </a></div>`) : null;

         // Handle Window On Click Event //
         window.addEventListener('click', this.onClick);

         // setting id for Opt Out of Microchip tag inside user popup //   
         userPopupTextElement.querySelectorAll("a").forEach(data => {
             if (data.textContent.includes("Opt out of myMicrochip Account")) {
               data.setAttribute('id', 'opt-out');
               data.addEventListener('click', this.deleteMyMicrochipAccount);
            }
         });
         if (!deleteToken || !userCookie || !userNameCookie) {
            document.getElementById('MyMicrochipMenu').style.display = "none"; 
         }
      },
      goToSearchPageHome() {
         window.location.href = 'https://www.microchip.com/en-us/search';
      },
      goToSearchPage(item) {
         window.location = `https://www.microchip.com/sitesearch/search/All/${item}`;
      },
      getSearchResultsApi() {
         let timeStampNow = new Date();
         timeStampNow = Date.parse(timeStampNow);
         const searchBarcontentElem = document.getElementsByClassName('searchbar-content')[0];
         const searchBarSuggestionsElem = document.getElementsByClassName('mchp-searchbar-suggestion')[0];

         HeadData.getUserSearchData(this.userSearchInput, timeStampNow)
         .then((data) => {
            this.searchSuggestionList = data.split('\n');
            if (this.searchSuggestionList.length) {
               searchBarcontentElem.style.display = 'none';
               searchBarSuggestionsElem.style.display = 'block';
            }
            return (data);
         })
         .catch(function(error) {
            console.log(error);
         });
      },

      clearSearchField() {
         const searchClearIcon = document.getElementsByClassName('search-clear')[0];
         this.userSearchInput = '';
         searchClearIcon.classList.add('hide-content');
      },

      // Mobile View  //
      toggleMobileNavMenu() {
         const mchplogo = document.getElementsByClassName('mchp-logo')[0];
         const hamburgerHolder = document.getElementsByClassName('hamburger-holder')[0];
         const headerIcons = document.getElementsByClassName('header-icons')[0];
         const mobileClose = document.getElementsByClassName('mobile-close')[0];
         let liParent = document.getElementsByClassName('parent-list')[0].getElementsByTagName('li');
         let liChild = document.getElementsByClassName('child-list')[0].getElementsByTagName('li');

         mchplogo.classList.contains('is-hidden') ? mchplogo.classList.remove('is-hidden') : mchplogo.classList.add('is-hidden');
         hamburgerHolder.classList.contains('is-hidden') ? hamburgerHolder.classList.remove('is-hidden') : hamburgerHolder.classList.add('is-hidden');
         mobileClose.classList.contains('is-active') ? mobileClose.classList.remove('is-active') : mobileClose.classList.add('is-active');
         mobileClose.classList.contains('is-active') ? liParent.forEach( el => el.classList.add( 'is-active' ) ) : liParent.forEach( el => el.classList.remove( 'is-active' ) );
         mobileClose.classList.contains('is-active') ? liChild.forEach( el => el.classList.add( 'is-active' ) ) : liChild.forEach( el => el.classList.remove( 'is-active' ) );

         !hamburgerHolder.classList.contains('is-hidden') ?
            document.getElementsByClassName('parent-list')[0].classList.add('hide-content'): 
            document.getElementsByClassName('parent-list')[0].classList.remove('hide-content');
   
         document.getElementsByClassName('child-list')[0].classList.add('hide-content');
         let headerSearch = document.getElementsByClassName('mchp-header-search')[0];
         if (headerSearch.style.display === 'block' && !hamburgerHolder.classList.contains('is-hidden') ) {
            mchplogo.classList.add('is-hidden');
            mobileClose.classList.add('is-active');
            hamburgerHolder.classList.contains('is-hidden') ? hamburgerHolder.classList.remove('is-hidden') : null;
         } else {
            headerIcons.classList.contains('is-active') ? headerIcons.classList.remove('is-active') : headerIcons.classList.add('is-active');
         }
      },
      handleMouseClickParent(index, event) {
         this.filteredItemMobile = this.myData.navData[index];
         this.parentIndexMobile = this.myData.navData.indexOf(this.filteredItemMobile);
         let ulParent = document.getElementsByClassName('parent-list')[0];
         let ulChild = document.getElementsByClassName('child-list')[0];
         if (this.filteredItemMobile.hasChild) {
             event.preventDefault();
             ulParent.classList.add('hide-content');
             ulChild.classList.remove('hide-content');
         }
      },
      handleMouseClickChild(item) {
         this.userSelectedArrayMobile.push({parent: this.filteredItemMobile, child: item});
         (item.hasChild) ? this.filteredItemMobile = item : null;
      },
      mobileBackBtnClick() {
         const filteredParentData = this.userSelectedArrayMobile.filter(d => { return d.child.title === this.filteredItemMobile.title; });
         if (filteredParentData.length) {
            const index = this.userSelectedArrayMobile.findIndex(d => d.parent.title === filteredParentData[0].parent.title);
            (index > -1) ? this.userSelectedArrayMobile.splice(index, 1) : null;
            this.filteredItemMobile = filteredParentData[0].parent;
         } else {
            let ulParent = document.getElementsByClassName('parent-list')[0];
            let ulChild = document.getElementsByClassName('child-list')[0];
            ulParent.classList.remove('hide-content');
            ulChild.classList.add('hide-content');
            this.filteredItemMobile = this.myData.navData[this.parentIndexMobile];
            this.userSelectedArrayMobile = [];
         }
      },
      onWindowResize() {
         const mchplogo = document.getElementsByClassName('mchp-logo')[0];
         const hamburgerHolder = document.getElementsByClassName('hamburger-holder')[0];
         const headerIcons = document.getElementsByClassName('header-icons')[0];
         const mobileClose = document.getElementsByClassName('mobile-close')[0];
         let liParent = document.getElementsByClassName('parent-list')[0].getElementsByTagName('li');
         let liChild = document.getElementsByClassName('child-list')[0].getElementsByTagName('li');

         if (hamburgerHolder.classList.contains('is-hidden')) {
            mobileClose.classList.remove('is-active');
            headerIcons.classList.remove('is-active');
         }
         hamburgerHolder.classList.remove('is-hidden');
         mchplogo.classList.remove('is-hidden');
         liParent.forEach( el => el.classList.remove( 'is-active' ) );
         liChild.forEach( el => el.classList.remove( 'is-active' ) )
      },
      // Window click event //
      onClick(event) {  
         const megaMenu = document.getElementById('mega-menu');
         let headerSearch = document.getElementsByClassName('mchp-header-search')[0];
         let searchIcon = document.getElementsByClassName('search-icon')[0];
         let userPopup = document.getElementById('MyMicrochipMenu');
         let ulChild = document.getElementsByClassName('child-list')[0];
         let ulParent = document.getElementsByClassName('parent-list')[0];
         const liChildElem = event.target.closest('.mchp-nav-link-holder');
         const mobileHamburgerIcon = document.getElementsByClassName('hamburger-holder')[0];
         const mobileMenuClick = document.getElementsByClassName('mchp-mobile-menu')[0].contains(event.target) ||
         ulParent.contains(event.target) || ulChild.contains(event.target) || liChildElem;
         let headerIcons = document.getElementsByClassName('header-icons')[0];
         const mobileClose = document.getElementsByClassName('mobile-close')[0];
         let mchplogo = document.getElementsByClassName('mchp-logo')[0];
         const clickOutside = headerSearch.contains(event.target) || searchIcon.contains(event.target) || megaMenu.contains(event.target);
         const clickOutsideMob = mobileClose.contains(event.target);
         
         if (clickOutsideMob && headerSearch.style.display === 'block') {
            headerIcons.classList.remove('is-active');
            mobileHamburgerIcon.classList.remove('is-hidden');
         }
         const moblieHamburgerIconsClick =  mobileHamburgerIcon.contains(event.target); // using for both desktop and small screens //
         if (mobileHamburgerIcon.contains(event.target) && headerSearch.style.display === 'block') {
            let liParent = document.getElementsByClassName('parent-list')[0].getElementsByTagName('li');
            let liChild = document.getElementsByClassName('child-list')[0].getElementsByTagName('li');
            mchplogo.classList.add('is-hidden');
            mobileHamburgerIcon.classList.add('is-hidden');
            mobileClose.classList.add('is-active');
            liParent.forEach( el => el.classList.add( 'is-active' ) );
            liChild.forEach( el => el.classList.add( 'is-active' ) );
         }
                  
         if (headerSearch.style.display === 'block' && headerSearch.contains(event.target) && mobileClose.classList.contains('is-active')) {
            headerIcons.classList.remove('is-active');
            mobileHamburgerIcon.classList.add('is-hidden');
         }

         if (!clickOutside) {
            (mobileClose.classList.contains('is-active') && headerSearch.style.display === 'block' && !mobileHamburgerIcon.classList.contains('is-hidden')) ? 
             headerIcons.classList.add('is-active') : null ;
            headerSearch.style.display === 'block' ? headerSearch.style.display = 'none' : null ;
            searchIcon.matches('.active') ? searchIcon.classList.remove('active') : null;
            mchplogo.classList.remove('is-hidden');       
         }
         userPopup.classList.add('HideMyMicrochipMenu');
         if (moblieHamburgerIconsClick && !megaMenu.classList.contains('hide-content')) {
            megaMenu.classList.add('hide-content');
            document.getElementsByClassName('mchp-dropdown_text')[this.myData.navData.indexOf(this.filteredItem)].classList.remove('menu-active');
         }
         if (mobileClose.classList.contains('is-active')) { //check for mobile screen //
            mchplogo.classList.add('is-hidden');
            if (searchIcon.contains(event.target)) {
               let headerIcons = document.getElementsByClassName('header-icons')[0];
               headerIcons.classList.remove('is-active');
               this.toggleMobileNavMenu();
            } else {
               (!moblieHamburgerIconsClick && !mobileMenuClick) ? this.toggleMobileNavMenu() : null;
            }
            (!mchplogo.classList.contains('is-hidden')) ?  mobileHamburgerIcon.classList.remove('is-hidden') : null;
         }
      },
      // Toggle Search Popup //
      toggleSearchPopup() {
         let headerSearch = document.getElementsByClassName('mchp-header-search')[0];
         let searchIcon = document.getElementsByClassName('search-icon')[0];
         const searchBarcontentElem = document.getElementsByClassName('searchbar-content')[0];
         const searchBarSuggestionsElem = document.getElementsByClassName('mchp-searchbar-suggestion')[0];
         this.searchSuggestionList = [];
         this.userSearchInput = '';
         searchBarcontentElem.style.display = 'block';
         searchBarSuggestionsElem.style.display = 'none';

         if (headerSearch.style.display !== 'block') {
            headerSearch.style.display = 'block';
            searchIcon.classList.add('active');
         } else {
            headerSearch.style.display = 'none';
            searchIcon.classList.remove('active');
         }
      },
      // Mouser Over Event User Popup Menu //
      handleMouseOverUserMenu() {
         const myMicrochipMenuElement = document.getElementById('MyMicrochipMenu');
         myMicrochipMenuElement.classList.remove('HideMyMicrochipMenu');
      },
      // Mouser Leave Event User Popup Menu //
      handleMouseLeaveUserMenu(event) {
         if(event.target) { 
            const myMicrochipMenuElement = document.getElementById('MyMicrochipMenu');
            myMicrochipMenuElement.classList.add('HideMyMicrochipMenu');
         }
      },
      // Mouse Over Event //
      handleMouseOverParent(index) {
         const megaMenu = document.getElementById('mega-menu');
         if (this.myData.navData.indexOf(this.filteredItem) !== index && this.myData.navData.indexOf(this.filteredItem) !== -1) {
            this.myData.navData[index].hasChild ? document.getElementsByClassName('mchp-dropdown_text')[index].classList.add('menu-active') : null;
            document.getElementsByClassName('mchp-dropdown_text')[this.myData.navData.indexOf(this.filteredItem)].classList.remove('menu-active')
         } else {
            this.myData.navData[index].hasChild ? document.getElementsByClassName('mchp-dropdown_text')[index].classList.add('menu-active') : null;
         }
         this.filteredItem = this.myData.navData[index];
         const stateChildIndex = this.userSelectedArray[index] !== undefined ? this.filteredItem.children.indexOf(this.userSelectedArray[index]) : -1;
         (stateChildIndex !== -1) ? this.updateCategoryDetailView(stateChildIndex) : document.getElementById("cat-detail").innerHTML = '';
         this.filteredItem.hasChild ? megaMenu.classList.remove('hide-content') : megaMenu.classList.add('hide-content');
      },
      // update category childrens //
      updateCategoryDetailView(index) {
         const parentIndex = this.myData.navData.indexOf(this.filteredItem);
         this.userSelectedArray[parentIndex] = this.myData.navData[parentIndex].children[index];
         let div = document.getElementById("cat-detail");
         div.innerHTML = '';
         const filteredItem = this.myData.navData[parentIndex].children[index];
         const newElement = `<div class="category-panel">
         <a href="${filteredItem.path}" class="category-title nav-link">
         <span>Browse ${filteredItem.title}</span><i class="fas fa-chevron-right chevron category-chevron"></i>   
         </a>
         <ul id="cat-menu-ul" class="subcategories-list"></ul>
         </div>`;
         filteredItem.hasChild ? div.insertAdjacentHTML("beforeEnd", newElement) : div.innerHTML = '';
         let ul = document.getElementById('cat-menu-ul');
         filteredItem.hasChild ? filteredItem.children.forEach((c, cIndex) => {
         ul.insertAdjacentHTML("beforeEnd", `<li class="subcategory">
         <a href="${c.path}" class="subcategory-name nav-link">${c.title}</a>
         </li>`);
         // Get the element List before appending with classname //
         let aProductFamily = document.getElementsByClassName('subcategory-name');
         c.hasChild ? c.children.forEach((subC) => {
            aProductFamily[cIndex].insertAdjacentHTML("afterend", `<ul>
            <li class="product-family">
               <a class="nav-link" href="${subC.path}">${subC.title}</a>
            </li>
            </ul>`);
         }) : null;
         
         }) : null;
      },
      // Mouse Over Event //
      handleMouseOverChild(index) {
         this.updateCategoryDetailView(index);
      },
      // Mouse Leave Event //
      handleMouseLeave(event) {
         if(event.target && event.target.nodeName === "DIV") {
               document.getElementById("mega-menu").classList.add('hide-content');
            document.getElementsByClassName('mchp-dropdown_text')[this.myData.navData.indexOf(this.filteredItem)].classList.remove('menu-active');         
         }
      },
      // usind Fetch to make the API call //
      deleteMyMicrochipAccount(event) {
         event.preventDefault();
         const deleteToken = window.$cookies.get("asdfdiuglkjhrsu");
         const confirmDelete = confirm("You will no longer receive myMicrochip notifications. Click OK to Confirm or Cancel to keep your myMicrochip notifications.");
         if (confirmDelete && deleteToken) {
            window.location.href = "https://www.microchip.com/mymicrochip/deletePreference.aspx";
         }
      },
      deleteCookie(name) {
         document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      },
      deleteUserCookies() {
         this.deleteCookie("Wwwmicrochipuser");
         this.deleteCookie("Wwwmicrochipusername");
         this.deleteCookie("Asdfdiuglkjhrsu");
      }
   },
}
</script>